import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTheme } from '../context/AppContext';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { XCircle, ArrowLeft, RefreshCcw, Sun, Moon } from 'lucide-react';

const CheckoutCancel = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  
  const paymentId = searchParams.get('payment_id');
  
  return (
    <div className="min-h-screen py-8 px-4 hero-gradient">
      <Button
        variant="ghost"
        size="icon"
        onClick={toggleTheme}
        className="fixed top-4 right-4 z-50"
      >
        {theme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
      </Button>
      
      <div className="max-w-xl mx-auto pt-16">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="text-center mb-8"
        >
          <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-10 h-10 text-red-500" />
          </div>
          <h1 className="font-syne text-3xl font-bold mb-2">Paiement annulé</h1>
          <p className="text-muted-foreground">
            Votre paiement a été annulé. Aucun montant n'a été débité.
          </p>
        </motion.div>
        
        <Card className="glass-card mb-6">
          <CardHeader>
            <CardTitle>Que s'est-il passé ?</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-muted-foreground">
              Vous avez annulé le processus de paiement ou une erreur s'est produite.
              Pas d'inquiétude, vous pouvez réessayer à tout moment.
            </p>
            <ul className="text-sm space-y-2 text-muted-foreground">
              <li>• Vérifiez que les informations de votre carte sont correctes</li>
              <li>• Assurez-vous d'avoir suffisamment de fonds disponibles</li>
              <li>• Désactivez temporairement votre bloqueur de publicités si nécessaire</li>
            </ul>
          </CardContent>
        </Card>
        
        <div className="flex justify-center gap-4">
          <Button variant="outline" onClick={() => navigate('/')}>
            <ArrowLeft className="w-4 h-4 mr-2" />
            Accueil
          </Button>
          <Button className="btn-primary" onClick={() => navigate(-1)}>
            <RefreshCcw className="w-4 h-4 mr-2" />
            Réessayer
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;
